import React, { Fragment } from "react";
import Formsy from "formsy-react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useMutation } from "@apollo/client";

import TextField from "../bootstrap/input";
import { useAsyncSetState } from "use-async-setstate";
import { useRef } from "react";
import { fetch } from "window-or-global";
import Modal from "../bootstrap/modal";
import { validateMobileVerificationMutation } from "../logic/mobile";

export default function Verification(props) {
  const { onSubmit, onClose, data } = props;
  const [loading, setLoading] = useAsyncSetState(false);
  const [error, setError] = useAsyncSetState(false);
  const formRef = useRef(null);
  const [validateMutation] = useMutation(validateMobileVerificationMutation)

  const handleVerify = async (input) => {
    const { code } = input;
      if (!code) {
        return;
      }
    await setLoading(true);
    try {
      const response = await validateMutation({variables: {
        mobileNumber: data?.mobile,
        code,
      }});
      if (response?.data?.classMethods?.MobileVerification?.validateMobileVerification) {
        return onSubmit && onSubmit();
      }

      await setError("Invalid Verification Code");
      await setLoading(false);
    } catch (err) {
      console.log({ err });
      await setError("Invalid Verification Code");
      await setLoading(false);
    }

    await setLoading(false);
  };

  return (
    <Modal
      title="Mobile Verification"
      show
      centered
      onClose={async () => onClose()}
      footer={
        <Container>
          <Row>
            <Col xs="auto mr-auto">
              <Button
                variant="black-text"
                onClick={async () => {
                  return onClose && onClose()
                }}
              >
                <i className="fas fa-arrow-left mr-2" />
                {"Return"}
              </Button>
            </Col>
            <Col xs="auto ml-auto">
              <Button
                type="submit"
                variant="login"
                disabled={loading}
                onClick={() => formRef.current.submit()}
              >
                {"Verify"}
              </Button>
            </Col>
          </Row>
        </Container>
      }
    >
      <Formsy
        ref={formRef}
        onValidSubmit={async (data) => {
          return handleVerify(data);
        }}
        onInvalidSubmit={(e) => {
          console.log("error", e);
        }}
      >
        <Container fluid className="no-gutters">
          {error && <Row>
            <Col xs={12} className="mx-auto">
              <div className="alert alert-danger my-1">
                {error}
              </div>
            </Col>
          </Row>}
          <Row>
            <Col>
              <div className="alert alert-primary my-3">
                {"Enter verification code to continue"}
              </div>
            </Col>
          </Row>
          <Row className="field-row">
            <Col>
              <TextField
                disabled={loading}
                type={"number"}
                autoFocus
                inputMode="numeric"
                name="code"
                placeholder="Verification Code"
                defaultValue=""
                required
                autoComplete="one-time-code"
              />
            </Col>
          </Row>
        </Container>
      </Formsy>
    </Modal>
  );
}
